/**
 * What the access screens say when something goes wrong.
 *
 * Kept apart from the pages so the wording can be tested, and so the rule that
 * matters most is in one place: a failed sign-in must never tell anyone
 * whether the address belongs to a member. The server already answers wrong
 * e-mail and wrong password identically; this only rewords that answer.
 */

export const OFFLINE =
  'Arcanum could not be reached. Check your connection and try again.';
export const UNAVAILABLE =
  'Arcanum is not answering just now. Try again in a moment.';
export const NOT_RECOGNISED = 'The email or password was not recognised.';
export const DEAD_RECOVERY_LINK =
  'This recovery link is invalid, expired or has already been used.';

// The server's one answer for an unknown address and a wrong password alike.
const SERVER_BAD_CREDENTIALS = 'Invalid email or password';

/** result: what AuthContext.login returns on failure ({ status, error }). */
export function loginErrorMessage({ status, error } = {}) {
  if (!status) return OFFLINE;
  if (status >= 500) return UNAVAILABLE;
  if (status === 401 && error === SERVER_BAD_CREDENTIALS) return NOT_RECOGNISED;
  // Lockout ("Too many login attempts. Try again in N seconds.") and anything
  // else the server words itself: its text is already written for members.
  return error || NOT_RECOGNISED;
}

/** For the second step and the other access forms: only the network is ours. */
export function accessErrorMessage({ status, error } = {}, fallback) {
  if (!status) return OFFLINE;
  if (status >= 500) return UNAVAILABLE;
  return error || fallback;
}
